import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { Box } from "@mui/material";
import { widgets as globalWidgets} from "../../widgets/config";
import useRequiredConnections from "@arelia-utils/helpers/useRequiredConnections";
import { ConnectionName } from "@arelia-types/connection";
import { Widget } from "@arelia-types/widget";
import EmptyState from "@arelia-components/ui-atoms/EmptyState";
import { GridLayout } from "./GridLayout";

type Props = {
  requiredConnectionNames?: ConnectionName[];
  widgets?: Widget[];
};

export default function Content({ requiredConnectionNames, widgets }: Props) {
  const { pathname } = useLocation();
  const hasRequiredConnections = useRequiredConnections(requiredConnectionNames);

  const [, page, tab] = useMemo(
    () => pathname.split("/").map((v) => `/${v}`),
    [pathname]
  );

  const filteredWidgets = (widgets || globalWidgets).filter((widget) =>
    (widget.page === page && widget.tab === tab)
  );

  const renderWidgets = () => (
    <>
      {filteredWidgets.map((widgetConfig: Widget) => {
        const { size, height, component: Component, id } = widgetConfig;

        return (
          <Box key={id}
            gridColumn={`span ${size}`}
            gridRow={`span ${height}`}
          >
            <Component config={widgetConfig} />
          </Box>
        )
      })}
    </>
  );

  return (
    <GridLayout>
      {hasRequiredConnections ?
        renderWidgets()
        :
        <Box
          gridColumn='span 12'
          gridRow='span 8'
          display='flex'
          alignItems='center'
        >
          <EmptyState
            minified={false}
            btnVariant="outlined"
            btnColor="secondary"
            btnMarginT={3}
          />
        </Box>
      }
    </GridLayout>
  )
}